module.exports = __webpack_public_path__ + "static/media/message-container.973d83d6.svg";